import { Row, Col } from "reactstrap"
import AvField from "availity-reactstrap-validation/lib/AvField"
import { useEffect, useState } from "react"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const ProjectLocation = props => {
  const [provinces, setprovinces] = useState()
  const [districts, setdistricts] = useState()
  const [sectors, setsectors] = useState()
  const [cells, setcells] = useState()
  const [villages, setvillages] = useState()

  const [rawProvinces, setrawProvinces] = useState()
  const [rawDistricts, setrawDistricts] = useState()
  const [rawSectors, setrawSectors] = useState()
  const [rawCells, setrawCells] = useState()
  const [rawVillages, setrawVillages] = useState()

  useEffect(() => {
    fetchProvinces()
  }, [])

  const fetchProvinces = () => {
    generalService.getProvinces().then(response => {
      if (response.status) {
        const provs = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setprovinces(provs)
        setrawProvinces(response.data)
      }
    })
  }

  const fetchDistricts = province_id => {
    //setsectors([])
    generalService.getDistricts(province_id).then(response => {
      //console.log("districts ", response)
      if (response.status) {
        const dists = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setdistricts(dists)
        setrawDistricts(response.data)
      }
    })
  }

  const fetchSectors = district_id => {
    generalService.getSectors(district_id).then(response => {
      //console.log("sectors ", response)
      if (response.status) {
        const secs = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setsectors(secs)
        setrawSectors(response.data)
      }
    })
  }

  const fetchCells = sector_id => {
    generalService.getCells(sector_id).then(response => {
      // console.log("cells ", response)
      if (response.status) {
        const cells = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcells(cells)
        setrawCells(response.data)
      }
    })
  }

  const fetchVillages = cell_id => {
    generalService.getVillages(cell_id).then(response => {
      if (response.status) {
        const villages = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setvillages(villages)
        setrawVillages(response.data)
      }
    })
  }

  const onChangeProvince = value => {
    setsectors([])
    setcells([])
    if (value != "") {
      const name = rawProvinces.find(item => item.id == value)?.name || "";
      props.onChangeProvince(name)
      fetchDistricts(value)
    }
  }

  const onChangeDistrict = value => {
    setcells([])
    if (value != "") {
      const name = rawDistricts.find(item => item.id == value)?.name || "";
      props.onChangeDistrict(name)
      fetchSectors(value)
    }
  }

  const onChangeSector = value => {
    if (value != "") {
      // set the sector name in parent component
      const name = rawSectors.find(item => item.id == value)?.name || "";
      props.onChangeSector(name)
      fetchCells(value)
    }
  }

  const onChangeCell = value => {
    // console.log("cell value ", value)
    // set the sector name in parent component
    const name = rawCells.find(item => item.id == value)?.name || "";
    props.onChangeCell(name)
    fetchVillages(value)
  }

  const onChangeVillage = value => {
    // console.log("village value ", value)
    // set the sector name in parent component
    const name = rawVillages.find(item => item.id == value)?.name || "";
    props.onChangeVillage(name)
  }
  return (
    <Row>
      {/* <h4>Project Location Details</h4> */}
      <Col md="3">
        <div className="mb-3">
          {props.disableFormFields? (
            <AvField
              name="project_province_name"
              type="text"
              value={props.data.project_province && props.data.project_province.name}
              disabled={true}
            />
          ) : (
            <AvField
              name="project_province_id"
              label="Select Province"
              type="select"
              onChange={e => onChangeProvince(e.target.value)}
              required
              value={props.data ? props.data.project_province_id : ""}
              disabled={props.disableFormFields}
            >
              <option value={""}>--Select--</option>
              {provinces}
            </AvField>
          )}
        </div>
      </Col>
      <Col md="3">
        <div className="mb-3">
          {props.disableFormFields? (
            <AvField
              name="project_district_name"
              type="text"
              value={props.data.project_district && props.data.project_district.name}              disabled={true}
            />
          ) : (
            <AvField
              name="project_district_id"
              label="Select District"
              type="select"
              onChange={e => onChangeDistrict(e.target.value)}
              required
              value={props.data ? props.data.project_district_id : ""}
              disabled={props.disableFormFields}
            >
              <option value={""}>--Select--</option>
              {districts}
            </AvField>
          )}
        </div>
      </Col>

      <Col md="3">
        <div className="mb-3">
          {props.disableFormFields? (
            <AvField
              name="project_sector_name"
              type="text"
              value={props.data.project_sector && props.data.project_sector.name}             disabled={true}
            />
          ) : (
            <AvField
              name="project_sector_id"
              label="Select Sector"
              type="select"
              required
              onChange={e => onChangeSector(e.target.value)}
              value={props.data ? props.data.project_sector_id : ""}
              disabled={props.disableFormFields}
            >
              <option value="">--Select--</option>
              {sectors}
            </AvField>
          )}
        </div>
      </Col>

      <Col md="3">
        <div className="mb-3">
          {props.disableFormFields? (
            <AvField
              name="project_cell_name"
              type="text"
              value={props.data.project_cell && props.data.project_cell.name}
              disabled={true}
            />
          ) : (
            <AvField
              name="project_cell_id"
              label="Select Cell"
              type="select"
              required
              onChange={e => onChangeCell(e.target.value)}
              value={props.data ? props.data.project_cell_id : ""}
              disabled={props.disableFormFields}
            >
              <option value="">--Select--</option>
              {cells}
            </AvField>
          )}
        </div>
      </Col>

      <Col md="3">
        <div className="mb-3">
          {props.disableFormFields? (
            <AvField
              name="project_village_name"
              type="text"
              value={props.data.project_village && props.data.project_village.name}
              disabled={true}
            />
          ) : (
            <AvField
              name="project_village_id"
              label="Select village"
              type="select"
              required
              onChange={e => onChangeVillage(e.target.value)}
              value={props.data ? props.data.project_village_id : ""}
              disabled={props.disableFormFields}
            >
              <option value="">--Select--</option>
              {villages}
            </AvField>
          )}
        </div>
      </Col>
    </Row>
  )
}

export default ProjectLocation
